<h2 mat-dialog-title>{{ getTitle() | translate }}</h2>
<div [hidden]="isLoading()">
  <mat-dialog-content>
    <ng-template #component></ng-template>
    <div *ngIf="!data?.readOnly && data?.knowledgeSourceKey">
      <ai-knowledge-apps-for-knowledge-source
        [knowledgeSourceId]="data.knowledgeSourceKey.knowledgeSourceId"
        [showInboxSettingsLink]="true"
      ></ai-knowledge-apps-for-knowledge-source>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="card-actions__secondary" *ngIf="showBack()">
      <button mat-stroked-button (click)="back()">{{ 'COMMON.BACK' | translate }}</button>
    </div>
    <div class="card-actions__primary">
      <button mat-stroked-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
      <ng-container *ngIf="showSubmit()">
        <button
          *ngIf="!data?.readOnly; else editButton"
          mat-flat-button
          color="primary"
          (click)="submit()"
          [disabled]="submitDisabled()"
        >
          {{ getSubmitAction() | translate }}
        </button>
      </ng-container>
    </div>
  </mat-dialog-actions>
</div>

<glxy-loading-spinner *ngIf="isLoading()"></glxy-loading-spinner>

<ng-template #editButton>
  <a mat-flat-button [href]="buildEditUrl()" color="primary" target="_blank">
    {{ 'COMMON.EDIT' | translate }}
    <mat-icon iconPositionEnd>open_in_new</mat-icon>
  </a>
</ng-template>
